import { combineReducers } from 'redux';
import device from './device';
import hunt from './hunt';
import hunter from './hunter';
import map from './map';
import settings from './settings';
import tag from './tag';
import team from './team';
import user from './user';
import notification from './notification';

const rootReducer = combineReducers({
    device,
    hunt,
    hunter,
    map,
    settings,
    tag,
    team,
    user,
    notification,
});

export default rootReducer;
